module.exports = __webpack_public_path__ + "img/云服务云开发.28f00098.jpg";